import React, { useState } from "react"; // Removed useEffect since we don't need it anymore
import GenerateHTML from "./GenerateHTML";
import toast from "react-hot-toast";

const Invoice = ({ order, transformedData }) => {
  const [isLoading, setIsLoading] = useState(false);
  const handleDownload = async () => {
    setIsLoading(true);

    try {
      // Generate PDF with the mapped data
      GenerateHTML({order, transformedData});
    } catch (error) {
      toast.error(`invoice failed`)
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="container">
        <button
          className="btn btn-danger mt-3"
          onClick={handleDownload}
          disabled={isLoading}
          style={{height:"40px",width:"160px"}}
        >
          {isLoading ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Generating...
            </>
          ) : (
            "Download Invoice"
          )}
        </button>
      </div>
    </>
  );
};

export default Invoice;
